/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type FulfillmentInventoryRequestDto = {
    /**
     * Inventory request (SOL) ID
     */
    id: number;
    /**
     * SOL code
     */
    requestCode: string;
    /**
     * SOL status
     */
    status: FulfillmentInventoryRequestDto.status;
    /**
     * When the SOL was resolved
     */
    resolvedAt?: string | null;
};
export namespace FulfillmentInventoryRequestDto {
    /**
     * SOL status
     */
    export enum status {
        PENDING = 'PENDING',
        APPROVED = 'APPROVED',
        REJECTED = 'REJECTED',
    }
}

